module.exports = __webpack_public_path__ + "static/img/32.f35d7073.gif";